import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '@services/role.guard';
import { AddressEditComponent } from './address-edit/address-edit.component';
import { AddressBookComponent } from './address-book.component';
import { ImportComponent } from '@modules/address-book/import/import.component';
import { ShipmentListComponent } from '@modules/shipments/components/shipments-list/shipment-list.component';
import { ShipmentsComponent } from '@modules/shipments/shipments.component';
import { ShipmentInfoComponent } from '@modules/shipments/components/shipment-info/shipment-info.component';

const route: Routes = [
  {
    path: 'address-book',
    canActivate: [RoleGuard],
    data: {expectedRole: '2'},
    children: [
      {
        path: '',
        component: AddressBookComponent
      },
      {
        path: 'edit/:id',
        component: AddressEditComponent
      },
      {
        path: 'new',
        component: AddressEditComponent
      },
      {
        path: 'import',
        component: ImportComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(route)
  ],
  exports: [
    RouterModule
  ]
})

export class AddressBookRoutingModule {
}




// WEBPACK FOOTER //
// ./src/app/modules/address-book/address-book-routing.module.ts